import type { PreviewNotes } from "~types/types";

export const PREVIEW_NOTES: PreviewNotes = {
    curationName: "BELOW FOLD: Magazine",
    description:
        "Package of stories utilizes nested magazine module to render cover image with mini table of contents.",
    links: [
        {
            name: "Module Library",
            url: "https://docs.google.com/document/d/1JORaUFwMtPyyoUflTRHKINyllR4zWIJV1bL66Abutis/edit?tab=t.0#heading=h.i5ub411yd7ep",
        },
        {
            name: "Figma",
            url: "https://www.figma.com/design/ecuKF9CTetHX35z2BJ8oa5/%F0%9F%90%A6%E2%80%8D%F0%9F%94%A5-Phoenix-Module-Repo?node-id=28-9472&m=dev",
        },
    ],
};
